import React from 'react';
import SamuraiGame from '../SamuraiGame';

const Click6SamuraiGrid = () => {
    return <SamuraiGame initialDrillIndex={9} />;
};

export default Click6SamuraiGrid;
